import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Python">
                <h1>Python Development Company</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Python is a popular and easy-to-learn programming language for
                  <Link to="/web-development">web development,</Link> CMS
                  portals, machine-learning solutions, and more. As a Python
                  development company, we serve organization-level clients with
                  our expertise.
                </p>
                <ul>
                  <li>Custom web solutions</li>
                  <li>Machine learning expertise</li>
                  <li>Organization-level solutions</li>
                  <li>Experienced Python team</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
